import AccountContainer from 'redux/containers/pages/account/AccountContainer'

export default AccountContainer
